module.exports = __webpack_public_path__ + "officialStatic/img/wlSpecBg.c227c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wlSpecBg.jpg
// module id = ISJT
// module chunks = 0